import React from "react";
import { bemName } from "../util/bemName";
import LoadingPanel from "../pages/LoadingPanel";

import "./Panel.scss";

const componentName = "Panel";

interface Props {
  id?: string;
  key?: string;
  title?: string;
  isLoading?: boolean;
  blockName?: string;
  defaultPadding?: boolean;
  children?: React.ReactNode | undefined;
}

export const Panel: React.FunctionComponent<Props> = ({
  id,
  key,
  title,
  isLoading,
  blockName,
  defaultPadding,
  children,
  ...props
}) => {
  if (isLoading) {
    return <LoadingPanel />;
  }

  const localBemName = (
    element?: string,
    ...modifiers: (string | undefined)[]
  ): string => {
    const blockNames = blockName ? [blockName, componentName] : componentName;

    return (
      (defaultPadding === false
        ? bemName(
            blockNames,
            element ? element + "NoPadding" : "noPadding",
            ...modifiers
          ) + " "
        : "") + bemName(blockNames, element, ...modifiers)
    );
  };
  return (
    <div className={localBemName()}>
      <div className={localBemName("container")}>
        <div className={localBemName("box")}>
          {title && <div className={localBemName("title")}>{title}</div>}

          <div className={localBemName("content")}>{children}</div>
        </div>
      </div>
    </div>
  );
};
